

export const checkMultipleParties = (balanceData) => {
    let hasMultiple = false;
    if (balanceData.balances && balanceData.balances.length > 0) {
        const bals = [];
        balanceData.balances.forEach(b => {
            const key = `${b.party.id}`;
            bals[key] = b;
        });
        const test = Object.keys(bals).length;
        if (test > 1) hasMultiple = true;
    }
    return hasMultiple;
}

export const getPartyData = (balanceData) => {
    let data = [];
    balanceData.balances.forEach(b => {
        const key = `${b.party.id}`;
        if (!data[key]) {
            const partyRec = {
                key: key,
                party: b.party,
                balances: []
            }
            partyRec.balances.push(b);
            data[key] = partyRec;
        } else {
            data[key].balances.push(b);
        }
    })
    return data;
}

export const removePaidPartyBals = (paymentRequest, savedPartyData) => {
    if (!paymentRequest.balances) return null;
    const parties = [];
    const refs = paymentRequest.balances.map(b => b.refId);
    savedPartyData.map((partyRec, idx) => {
       parties[idx] = {balances: partyRec.balances.filter(b => !refs.includes(b.refId)), key: partyRec.key, party: partyRec.party};
    });
    return parties.filter(p => p.balances.length > 0);
}